import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import Select from 'react-select';

const StaffEdit = () => {
    const { id } = useParams();
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState('');
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();
    const [selectedUserType, setSelectedUserType] = useState(null);
    const [userTypeOptions, setUserTypeOptions] = useState([]);

    const [formData, setFormData] = useState({
        UserTypeId: '',
        FirstName: '',
        LastName: '',
        Code: '',
        Email: '',
        staffnote: '',
        PhoneNumber: '',
        DateOfJoining: '',
        DateOfLeaving: '',
        DateOfBirth: '',
        bloodGroup:'',
        Idcard: '',
        IdCardNumber: '',
        Staffnote: '',
        LicenseNo: '',
        Expirydate: '',
        CreatedBy: userId,
        CompanyID: companyId,
        CreatedDate: new Date(),
        IsLoginNeeded: '',
        isSubmit: false,
        userType: '',
    });

    const fetchUserTypes = async () => {
        try {
            const response = await fetchData('UserTypeApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(userType => ({
                    value: userType.id,
                    label: userType.name
                }));
                setUserTypeOptions(options);
            }
        } catch (error) {
            console.error('Error fetching user types:', error);
        }
    };

    const handleUserTypeChange = (selectedOption) => {
        setSelectedUserType(selectedOption);
        setFormData((prevData) => ({
            ...prevData,
            UserTypeId: selectedOption ? selectedOption.value : '',
        }));
    };

    useEffect(() => {
        fetchUserTypes();
    }, []);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, token, logout]);

    useEffect(() => {
        fetchData('StaffApi', `/StaffCreate/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    const { response_data } = response;
                    setFormData(response_data);
                    const selectedOption = userTypeOptions.find(option => option.value === response_data.UserTypeId);
                    setSelectedUserType(selectedOption);
                }
            })
            .catch((error) => {
                console.error('Error fetching Staff Details:', error);
            });
    }, [id, userTypeOptions, token]);

    const formatDateForInput = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        let month = (date.getMonth() + 1).toString().padStart(2, '0');
        let day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsLoading(true);

        setFormData(prevData => ({
            ...prevData,
            UpdatedBy: userId,
        }));

        updateData('StaffApi', `${id}`, formData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                history.push('/StaffIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
                setIsLoading(false);
            });
    };
    const isDriver = selectedUserType && selectedUserType.label === 'Driver';

    return (
       
            <div className="w-full max-w-sm container mt-6 mx-auto">
                <form onSubmit={handleSubmit}>

                    <div className='w-full mb-2 flex items-center'>
                    <h4 className='psheading flex-grow linkcolor' style={{ fontFamily: 'Times New Roman', color: 'black' }}>
                    <b>Staff Edit</b> </h4>

                        <Button
                            variant="contained"
                            style={{ marginLeft: '8px', backgroundColor: '#006400', color: 'white' }}
                            onClick={handleSubmit}
                        >
                            Update
                        </Button>

                        <Button
                            variant="contained"
                            color="error"
                            component={Link}
                            to="/StaffIndex"
                            className="linkcolor"
                            style={{ marginLeft: '8px' }}
                        >
                            Cancel
                        </Button>


                    </div>
                    {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                    {successMessage && <p className="text-green-500">{successMessage}</p>}


                    <div className="w-full mb-4 flex">
                    <div className="w-1/5 mr-2">
                        <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="user type">
                            User Type
                            <span className="text-red-500">*</span>
                        </label>
                        <Select
                            value={selectedUserType || (formData.usertype ? { value: formData.usertype, label: formData.usertype } : '')}
                            onChange={handleUserTypeChange}
                            options={userTypeOptions}
                            placeholder="Select User Type"
                            isSearchable
                        />
                    </div>
                        <div className="w-1/5 mr-2">
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="firstname">
                                First Name
                                <span className="text-red-500">*</span>
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.firstName}
                                name="firstName"
                                onChange={handleChange}
                                type="text" placeholder="Enter First Name"
                                maxLength={30}
                            />
                        </div>
                        <div className="w-1/5 mr-2">
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="code">
                                Last Name
                                <span className="text-red-500">*</span>
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                               value={formData.lastName}
                               name="lastName"
                               onChange={handleChange}
                                type="text" placeholder="Enter Last Name"
                                maxLength={30}
                            />
                        </div>
                        
                        <div className="w-1/5 mr-2">
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="fromDate" style={{ fontSize: '16px' }}>
                                Date Of Joining
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="date" 
                                value={formatDateForInput(formData.dateOfJoining)}
                                onChange={handleChange}
                                name="dateOfJoining"
                          
                            />
                        </div>
                    </div>
                    {/* Second row of fields */}
                    <div className="w-full mb-4 flex">
                        {/* DOB */}
                        <div className="w-1/5 mr-2">
                            <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="fromDate" style={{ fontSize: '16px' }}>
                                DOB
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="date" 
                                value={formatDateForInput(formData.dateOfBirth)}
                                onChange={handleChange}
                                name="dateOfBirth"
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="fromDate" style={{ fontSize: '16px' }}>
                                Blood Group
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="text" value={formData.bloodGroup} 
                                onChange={handleChange}
                                placeholder="Enter Blood Group"
                                name="bloodGroup"
                            />
                        </div>

                        {/* Contact Number */}
                        <div className="w-1/5 mr-2">
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="PhoneNumber">
                                Contact Number
                                <span className="text-red-500">*</span>
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                               value={formData.phoneNumber}
                               onChange={handleChange}
                               name="phoneNumber"
                                type="text" placeholder="Enter Contact Number"
                                maxLength={15}
                            />
                        </div>
                        {/* Email */}
                        <div className="w-1/5 mr-2">
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="email">
                                Email
                                <span className="text-red-500">*</span>
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.email}
                                onChange={handleChange}
                                name="email"
                                type="text" placeholder="Enter Email"
                                maxLength={40}
                            />
                        </div>
                        
                        {/* Idcard Type */}
                        <div className="w-1/5 mr-2">
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="Idcardtype">
                                Idcard Type
                                <span className="text-red-500">*</span>
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                               value={formData.idcard}
                               onChange={handleChange}
                               name="Idcard"
                                type="text" placeholder="Enter IdCardType"
                                maxLength={40}
                            />
                        </div>
                        {/* Idcard NO */}
                        <div className="w-1/5 mr-2">
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="Idcardno">
                                IdCard No
                                <span className="text-red-500">*</span>
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.idCardNumber}
                                onChange={handleChange}
                                name="idCardNumber"
                                type="text" placeholder="Enter Idcard No"
                                maxLength={40}
                            />
                        </div>
                    </div>

                   {/* Third row of fields */}
            <div className="w-full mb-4 flex">
            {/* {selectedUserType && selectedUserType.label === 'Driver' && (
        <>
                        <div className="mr-2">
                            <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="licenseno" style={{ fontSize: '16px' }}>
                                License No
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="text" placeholder="Enter LicenseNo" 
                                value={formData.licenseNo}
                                onChange={handleChange}
                                name="licenseNo"
                            />
                        </div>
                        <div className="w-1/5 mr-2">
                            <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="expirydate" style={{ fontSize: '16px' }}>
                                License ExpiryDate
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="date" 
                                value={formatDateForInput(formData.Expirydate)}
                                onChange={handleChange}
                                name="Expirydate"
                            />
                        </div>
                        </>
                 )} */}
                            {/* Conditional fields for Driver */}
                {selectedUserType && selectedUserType.label === 'Driver' && (
                    <>
                        <div className="w-1/5 mr-2">
                            <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="LicenseNo" style={{ fontSize: '16px' }}>
                                License No
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="text"
                                placeholder="Enter License No"
                                value={formData.licenseNo}
                                onChange={handleChange}
                                name="licenseNo"
                            />
                        </div>
                        <div className="w-1/5 mr-2">
                            <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="Expirydate" style={{ fontSize: '16px' }}>
                                License Expiry Date
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="date"
                                value={formatDateForInput(formData.expirydate)}
                                onChange={handleChange}
                                name="expirydate"
                            />
                        </div>
                    </>
                )}
                <div className="w-1/5 mr-2">
                    <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="fromDate" style={{ fontSize: '16px' }}>
                        Date Of Leaving
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" 
                        value={formatDateForInput(formData.dateOfLeaving)} 
                        onChange={handleChange}
                        name="dateOfLeaving"
                    />
                </div>
                <div className="w-1/5 mr-2">
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="staffnote">
                               Staff Note
                                <span className="text-red-500">*</span>
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                 value={formData.staffnote}
                                 onChange={handleChange}
                                 name="staffnote"
                                type="text" placeholder="Enter Staff note"
                                maxLength={40}
                            />
                        </div>
                {/* <div className="w-1/5 mr-2 flex items-center">
                    <div className="form-group">
                        <span style={{ marginRight: '5px', marginTop: '25px', fontWeight: 'bolder' }}>Login Needed</span>
                        <input
                            type="checkbox"
                            style={{ marginTop: '15px' }}
                            checked={isLoginNeeded}
                            onChange={handleChange}
                        />
                    </div>
                </div> */}
</div>
                </form>
                </div>
         
    );
}

export default StaffEdit;


